import { Button, Spinner } from '@mgh-app/component-library';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { selectRoomById } from 'services/RoomService';
import {
  useGetTemperatureValuesQuery,
  useSetTemperatureAwayModeMutation,
} from 'services/ThingsService';
import { useAppSelector } from 'store';
import {
  display,
  fontSize,
  fontWeight,
  gap,
  gridTemplateColumns,
  gridTemplateRows,
  justifySelf,
  margin,
  textAlign,
  textColor,
  twCls,
} from 'style';
import { ChangeButton } from '../Schedule/ChangeButton';

const defaultAwaySetPoint = 5.0;

export const AwayPage = () => {
  const [setPoint, setSetPoint] = useState(5);
  const { roomId = '', temperatureThingId = '' } = useParams();
  const room = useAppSelector((state) => selectRoomById(state, roomId));
  const { data: temperatureData, isLoading: isLoadingTemperature } =
    useGetTemperatureValuesQuery(temperatureThingId);
  const [saveAwayMode] = useSetTemperatureAwayModeMutation();

  useEffect(() => {
    if (temperatureData?.away) {
      setSetPoint(temperatureData.away.setPoint ?? defaultAwaySetPoint);
    }
  }, [temperatureData?.away, temperatureData?.setPoint]);

  const onConfirmAway = async () => {
    await saveAwayMode({ thingId: temperatureThingId, away: { setPoint } });
  };

  return (
    <>
      {isLoadingTemperature ? (
        <Spinner />
      ) : (
        <div
          className={twCls(
            display('grid'),
            margin('mx-4', 'my-2'),
            textColor('text-grey-900'),
            gridTemplateColumns('grid-cols-1'),
            gridTemplateRows('grid-rows-4-min'),
            gap('gap-8'),
          )}
        >
          <div className={twCls(margin('mt-6'), fontSize('text-sm'))}>Adjust Temperature:</div>
          <div
            className={twCls(
              margin('mt-3'),
              fontSize('text-3xl'),
              justifySelf('justify-self-center'),
              display('flex'),
              gap('gap-8'),
            )}
          >
            <ChangeButton
              variant="UP"
              onClick={() => setSetPoint((sp) => (sp < 30 ? sp + 0.5 : sp))}
            />
            <div className={twCls(fontWeight('font-medium'))}>
              <span>{setPoint.toFixed(1)}</span>&nbsp;°C
            </div>
            <ChangeButton
              variant="DOWN"
              onClick={() => setSetPoint((sp) => (sp > 5 ? sp - 0.5 : sp))}
            />
          </div>
          <p className={twCls(fontSize('text-lg'), textAlign('text-center'))}>{room?.nickName}</p>
          <p className={twCls(textAlign('text-center'))}>
            Your normal schedule will resume after turning off away mode.
          </p>
          <Button onClick={onConfirmAway}>Confirm Away Temperature</Button>
        </div>
      )}
    </>
  );
};
